<template>
  <el-dialog
    title="地图标记"
    :visible.sync="dialog.show"
    width="60%"
    append-to-body
  >
    <div class="screen_body">
      <cesium @lnglat="lnglat" :CesiumData="dataMap"></cesium>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog.show = false">取 消</el-button>
      <el-button type="primary" @click="submit" v-preventReClick>确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cesium from "../Cesium.vue";
export default {
  components: { cesium },
  data() {
    return {
      dialog: {
        show: false,
      },
      // 区划
      dataMap: {
        clickMarkerShow: true, //  true  扎点，false  区划
        loglat: "", // （1.扎点坐标    2.区划中心点）
        points: "", // 区划坐标系
        type: 1, //  1  新增，2  修改
      },
      position: "",
    };
  },
  mounted() {},
  methods: {
    lnglat(val) {
      this.position = val.addPosition;
    },
    submit() {
      this.$emit("getPosition", this.position);
      this.dialog.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.screen_body {
  width: 100%;
  height: 50vh;
}
</style>
